import React, {PureComponent} from "react";
import {DatePicker, Button} from "antd";
const { RangePicker } = DatePicker;
class FilterBar extends PureComponent {
    constructor(props){
        super(props)
        this.state = {
            startDate: "",
            endDate: ""
        }
    }
    onDateChange = (date, dateString) => {
        this.setState({ startDate: dateString[0], endDate: dateString[1] });
    }
    handleSearchClick = () => {
        const {onSearch} = this.props;
        const {startDate, endDate} = this.state;
        if(onSearch && startDate && endDate){
            onSearch(startDate, endDate);
        }
    }
  render() {
    const {translate} = this.props;
    const {startDate, endDate} = this.state;
    return (
      <div className="filter-bar">
        <RangePicker onChange={this.onDateChange}/>
        <Button 
            type="primary" 
            disabled={!startDate || !endDate}
            onClick={this.handleSearchClick}>
                {translate("lenderRegistrationsPage.search_button_text")}
        </Button>
      </div>
    );
  }
}

export default FilterBar;